import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllSubCategory = createAsyncThunk(
  "subCategories/fetchAllSubCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/subCategory`);

      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddSubCategory = createAsyncThunk(
  "subCategories/AddSubCategory",
  async ({ selectedSuperCategoryId, data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSuperCategoryId)
      // console.log(" Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("name_en", data.nameEn);
      formData.append("name_ar", data.nameAr);
      formData.append("title", data.title);
      formData.append("area", data.selectedAreaId);
      formData.append("category", data.selectedSuperCategoryId);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append(
          "image",
          compressedFile,
          `subCategory-${Date.now()}.webp`
        );
      }

      // console.log("Sending subCategory with FormData...");

      const createResponse = await axios.post(
        `${BASE_URL}/subCategory`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      // console.log("Brand created with image:", createResponse.data);

      return createResponse.data.data;
    } catch (error) {
      console.error(
        "AddSubCategory failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to add subCategory"
      );
    }
  }
);

export const deleteSubCategoryById = createAsyncThunk(
  "subCategories/deleteSubCategoryById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/subCategory/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("✅ subCategory deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("❌ Delete failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to delete subCategory"
      );
    }
  }
);

export const updateSubCategoryById = createAsyncThunk(
  "subCategories/updateSubCategoryById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();
      formData.append("name_en", data.nameEn);
      formData.append("name_ar", data.nameAr);
      formData.append("title", data.title);
      formData.append("area", data.area);
      formData.append("category", data.category);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(
        `${BASE_URL}/subCategory/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: token,
          },
        }
      );

      return response.data.updatedsubCategory || response.data;
    } catch (error) {
      console.error("❌ Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update subCategory"
      );
    }
  }
);

const subCategoriesSlice = createSlice({
  name: "subCategories",
  initialState: {
    allSubCategories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSubCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSubCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.allSubCategories = action.payload; // ✅ هنا بتخزن الداتا
      })
      .addCase(fetchAllSubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default subCategoriesSlice.reducer;

// Export actions and reducer
